export enum LocationStatus{
    Full = 'Full',
    PartiallyFilled = 'PartiallyFilled',
    Empty = "Empty",
    
}